export default "__VITE_ASSET__CymqHW_$__"